import URLBuilder from "./URLBuilder";

export const PageURL = new URLBuilder();

export default PageURL;
